import { EVENT_NAMES } from 'constants/eventNames'
import { trackEvent } from 'utils/analyticsService'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

function resumeTestSuccess(props, allTestStatus, param) {
    trackEvent(
        EVENT_NAMES.TAP_RESUME_TEST_WEB,
        'User comes back to the test after being logged out and clicks on the resume test button',
        {
            [ANALYTICS_KEYS.SUCCESS]: true,
            [ANALYTICS_KEYS.USER_TEST_ID]: allTestStatus[param]['userTestId'],
        },
    )
}

function resumeTestFailure(props, allTestStatus, param, error) {
    trackEvent(
        EVENT_NAMES.TAP_RESUME_TEST_WEB,
        'User comes back to the test after being logged out and clicks on the resume test button',
        {
            [ANALYTICS_KEYS.FAILURE]: true,
            [ANALYTICS_KEYS.REASON_FOR_FAILURE]: error,
            [ANALYTICS_KEYS.USER_TEST_ID]: allTestStatus[param]['userTestId'],
        },
    )
}

function startTestSuccess(props, res) {
    trackEvent(
        EVENT_NAMES.TAP_START_TEST_WEB,
        'Usertaps on start test button',
        {
            [ANALYTICS_KEYS.SUCCESS]: true,
            [ANALYTICS_KEYS.USER_TEST_ID]: res.data.userTestId,
        },
    )
}

function startTestFailure(props, error) {
    trackEvent(
        EVENT_NAMES.TAP_START_TEST_WEB,
        'Usertaps on start test button',
        {
            [ANALYTICS_KEYS.FAILURE]: true,
            [ANALYTICS_KEYS.REASON_FOR_FAILURE]: error,
            [ANALYTICS_KEYS.USER_TEST_ID]:
                'testStatus' in props.testStatus
                    ? props?.testStatus?.testStatus?.data.userTestId
                    : null,
        },
    )
}

function pageLoadSuccess(props, instructionsData) {
    trackEvent(
        EVENT_NAMES.INSTRUCTION_LANDING_WEB,
        'User lands on the instruction page of the test',
        {
            [ANALYTICS_KEYS.SUCCESS]: true,
            [ANALYTICS_KEYS.USER_TEST_ID]:
                'testStatus' in props.testStatus
                    ? props.testStatus?.testStatus?.data?.userTestId
                    : null,
        },
    )
}

export {
    startTestSuccess,
    startTestFailure,
    resumeTestSuccess,
    resumeTestFailure,
    pageLoadSuccess,
}
